import React, { useRef, useState } from "react";
import { message, Button, Modal, Card, Form, Input } from "antd";
import { useSelector } from "react-redux";
import CircularProgress from "../CircularProgress";
import VendorService from "../../service/VendorService";
import notify from "../../Notification";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";

const ChangePassword = (props) => {
  let title = "Change Password";

  const [data, setData] = useState({
    oldpassword: "",
    password: "",
    cpassword: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { loader, alertMessage, user, showMessage } = useSelector(
    ({ auth }) => auth,
  );
  let lastPassword = localStorage.getItem("user");
  let password = JSON.parse(lastPassword);
  const formRef = useRef();
  const onFinish = async () => {
    if (data.oldpassword !== password.password) {
      notify.openNotificationWithIcon(
        "error",
        "Error",
        "Your old password is not matched!",
      );
      return;
    }
    setIsLoading(true);
    const updateData = {
      _id: user?._id,
      password: data?.password,
    };

    await VendorService.editVendor(updateData)
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
          setIsLoading(false);
          window.localStorage.setItem(
            "user",
            JSON.stringify({ ...user, password: data.password }),
          );
          // localStorage.setItem("vendor-cred", updateData);
          // dispatch(userSignInDataSuccess({ ...user, password: data.password }))
          setData({
            oldpassword: "",
            password: "",
            cpassword: "",
          });
          formRef.current.setFieldsValue({
            oldpassword: "",
            password: "",
            cpassword: "",
          });
          notify.openNotificationWithIcon(
            "success",
            "Success",
            "Your password has been successfully updated",
          );

          const oldCred = window.localStorage.getItem("vendor-cred");
          if (oldCred) {
            const stringData = JSON.parse(oldCred);
            const newCred = {
              uniqueId: stringData.uniqueId,
              password: data.password,
            };
            const stringifyData = JSON.stringify(newCred);
            localStorage.setItem("vendor-cred", stringifyData);
          }
          props.setVisibleModal(false);
        } else {
          notify.openNotificationWithIcon("error", "Error", response.message);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        notify.openNotificationWithIcon("error", "Error", err);
      });
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setData({
      ...data,
      [name]:
        !isNaN(parseFloat(value)) && isFinite(value) ? parseInt(value) : value,
    });
  };

  return (
    <Modal
      title={null}
      closable={false}
      onCancel={() => {
        setData({
          oldpassword: "",
          password: "",
          cpassword: "",
        });

        props.setVisibleModal(false);
      }}
      visible={props.visibleModal}
      destroyOnClose={true}
      footer={null}
    >
      <Card title={title} style={{ marginBottom: "0px" }}>
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 900 }}
          initialValues={data}
          ref={formRef}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="Old Password"
            name="oldpassword"
            rules={[
              {
                required: data?.oldpassword === "",
                message: "Please enter your old password!",
              },
            ]}
          >
            <Input.Password
              type="password"
              placeholder="Enter Old Password"
              value={data.oldpassword}
              name="oldpassword"
              id="oldpassword"
              onChange={handleInputChange}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="password"
            rules={[
              {
                required: data?.password === "",
                message: "Please enter your new password!",
              },
              {
                validator: (rule, value) => {
                  if (value.length < 6) {
                    return Promise.reject(
                      "Password must be at least 6 characters long and include 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character.",
                    );
                  }
                  if (
                    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*!])[A-Za-z\d@#$%^&*!]+$/.test(
                      value,
                    )
                  ) {
                    return Promise.reject(
                      "Password must include 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character.",
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Password
              type="password"
              placeholder="Enter New Password"
              value={data.password}
              name="password"
              id="password"
              onChange={handleInputChange}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            name="cpassword"
            rules={[
              {
                required: data?.cpassword === "",
                message: "Please enter your confirm password!",
              },
              {
                validator: (rule, value) => {
                  if (value && value !== data?.password) {
                    return Promise.reject(
                      "New password and confirm password are not match!",
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Password
              type="password"
              placeholder="Enter Confirm Password"
              value={data.cpassword}
              name="cpassword"
              id="cpassword"
              onChange={handleInputChange}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
          <Form.Item
            wrapperCol={{ offset: 16, span: 16 }}
            style={{ marginLeft: "20%" }}
          >
            <Button loading={isLoading} type="primary" htmlType="submit">
              {"Update"}
            </Button>
            <Button
              style={{ padding: "0 25px" }}
              type="primary"
              onClick={() => {
                setData({
                  oldpassword: "",
                  password: "",
                  cpassword: "",
                });
                props.setVisibleModal(false);
              }}
            >
              Close
            </Button>
          </Form.Item>

          {loader ? (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          ) : null}
          {showMessage ? message.error(alertMessage.toString()) : null}
        </Form>
      </Card>
    </Modal>
  );
};

export default ChangePassword;
